document.addEventListener('DOMContentLoaded', function () {
  var productGrid = document.querySelector('#CollectionLoop');
  if (!productGrid) return; // Not on a collection page

  // Temporarily use Shopify's standard pagination.
  return;


  var isLoading = false;
  var nextUrl = getNextUrl(document);
  hidePagination(document);

  // If there's no next page, do nothing
  if (!nextUrl) return;

  // Create a sentinel element we can observe near the bottom
  var sentinel = document.createElement('div');
  sentinel.id = 'infinite-scroll-sentinel';
  sentinel.style.width = '100%';
  sentinel.style.height = '1px';
  sentinel.style.marginTop = '1px';

  // Put sentinel just after the grid
  var parent = productGrid.parentNode;
  parent.appendChild(sentinel);

  // Use IntersectionObserver for smooth triggering near the bottom
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    },
    {
      root: null,
      rootMargin: '400px 0px 0px 0px', // start loading a bit before it is fully visible
      threshold: 0.1
    }
  );

  observer.observe(sentinel);

  // ---------- helpers ----------

  function getNextUrl(doc) {
    // Your theme's custom "Next" link
    var nextLink = doc.querySelector('nav.pagination-custom a.pagination-custom__next');

    // Fallbacks
    if (!nextLink) {
      nextLink =
        doc.querySelector('.pagination a[rel="next"]') ||
        doc.querySelector('.pagination__item--next a') ||
        doc.querySelector('.pagination__arrow--next a');
    }

    var headNext = doc.querySelector('link[rel="next"]');

    var href = nextLink ? nextLink.getAttribute('href') :
              headNext ? headNext.getAttribute('href') :
              null;

    return href || null;
  }

  function hidePagination(root) {
    var pagination =
      root.querySelector('nav.pagination-custom') ||
      root.querySelector('.pagination') ||
      root.querySelector('.collection__pagination');

    if (pagination) {
      pagination.style.display = 'none';
    }
  }

  function showLoader(show) {
    var loader = document.querySelector('.grid_loader');
    if (loader) {
      loader.style.display = show ? 'block' : 'none';
    }
  }

  function fetchPage(url, attempt) {
    attempt = attempt || 0;

    return fetch(url).then(function (response) {
      if (response.status === 429 && attempt < 4) {
        var retryAfter = parseInt(response.headers.get('Retry-After'), 10);
        var delay = retryAfter > 0
          ? retryAfter * 1000
          : Math.pow(2, attempt) * 1500;

        return new Promise(function (resolve) {
          setTimeout(resolve, delay);
        }).then(function () {
          return fetchPage(url, attempt + 1);
        });
      }

      if (!response.ok) {
        throw new Error('Pagination request failed with status ' + response.status);
      }

      return response.text();
    });
  }

  function loadNextPage() {
    if (!nextUrl || isLoading) {
      if (!nextUrl && observer) {
        observer.disconnect();
      }
      return;
    }

    isLoading = true;
    showLoader(true);

    fetchPage(nextUrl)
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newGrid = doc.querySelector('#CollectionLoop');
        if (!newGrid) {
          throw new Error('Pagination response did not contain #CollectionLoop');
        }

        // Capture the following page before moving nodes out of the fetched document
        var followingUrl = getNextUrl(doc);

        Array.prototype.slice.call(newGrid.children).forEach(function (item) {
          productGrid.appendChild(item);
        });

        hidePagination(doc);
        nextUrl = followingUrl;

        if (!nextUrl) {
          // No more pages – stop observing & remove sentinel
          if (observer) observer.disconnect();
          if (sentinel && sentinel.parentNode) {
            sentinel.parentNode.removeChild(sentinel);
          }
        }

        isLoading = false;
        showLoader(false);

        // Re-arm the observer in case the sentinel stayed inside the viewport
        if (nextUrl && observer && sentinel) {
          observer.unobserve(sentinel);
          observer.observe(sentinel);
        }
      })
      .catch(function (err) {
        console.error('Infinite scroll error:', err);
        isLoading = false;
        showLoader(false);
      });
  }
});

